import React from 'react';
import Draggable from 'react-draggable';
import styled from 'styled-components';

const WindowContainer = styled.div`
  position: fixed;
  top: 30%;
  left: 40%;
  transform: translate(-50%, -50%);
  background: white;
  border: 2px solid black;
  min-width: 300px;
  max-width: 400px;
  font-family: "Pixelify Sans", sans-serif;
  z-index: 1000;
`;

const TitleBar = styled.div`
  background: black;
  color: white;
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-family: "Pixelify Sans", sans-serif;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0 0.5rem;
  
  &:hover {
    opacity: 0.8;
  }
`;

const Content = styled.div`
  padding: 1rem;
  
  h2 {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  
  p {
    line-height: 1.5;
    margin: 0;
  }
`;

const AboutWindow = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <Draggable handle=".handle">
      <WindowContainer>
        <TitleBar className="handle">
          <span>about.exe</span>
          <CloseButton onClick={onClose}>×</CloseButton>
        </TitleBar>
        <Content>
          <h2>about//</h2>
          <p>
            We are a holding company for signal amplification in a world of noise.
          </p>
        </Content>
      </WindowContainer>
    </Draggable>
  );
};

export default AboutWindow;